import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=3bbbb72a&scoped=true"
import script from "./commodity.vue?vue&type=script&lang=js"
export * from "./commodity.vue?vue&type=script&lang=js"
import style0 from "./commodity.vue?vue&type=style&index=0&id=3bbbb72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbbb72a",
  null
  
)

export default component.exports